export const AuthRoles = {
  ROLES_SUPERADMIN: ["SUPERADMIN"], // Admin has access
  ROLES_OPERATOR: ["SUPERADMIN", "OPERATOR"], // Only Admin and Operator has access
  ROLES_USER: ["SUPERADMIN", "OPERATOR", "WARGA"], // Only Admin & Operator & User has access
};

export const RolesName = {
  ROLES_SUPERADMIN: "SUPERADMIN",
  ROLES_OPERATOR: "OPERATOR",
  ROLES_USER: "WARGA",
};

export const RoleDropDown = [
  {
    label: "Operator",
    value: "operator",
  },
  {
    label: "User",
    value: "warga",
  },
];
